import { render, staticRenderFns } from "./energyStrategynew.vue?vue&type=template&id=88faf474&scoped=true&"
import script from "./energyStrategynew.vue?vue&type=script&lang=js&"
export * from "./energyStrategynew.vue?vue&type=script&lang=js&"
import style0 from "./energyStrategynew.vue?vue&type=style&index=0&id=88faf474&lang=less&scoped=true&"
import style1 from "./energyStrategynew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88faf474",
  null
  
)

export default component.exports